import type { ComponentContentSchema } from '@vibesites/runtime';
import { usePropertyField, EditableToken, useContentToken } from '@vibesites/runtime/react';

export function AccessibilityStatement() {
  const domain = usePropertyField('property_domain') as string || '';
  const unavailableMessage = useContentToken('accessibilitystatement.unavailable_message') as string;

  const iframeSrc = domain
    ? `https://portal.audioeye.com/accessibility-statement.html?domain=${encodeURIComponent(domain)}`
    : '';

  return (
    <section className="bg-white py-8 md:py-12">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {iframeSrc ? (
          <iframe
            src={iframeSrc}
            title="Accessibility Statement"
            className="w-full border-0"
            style={{ height: '2300px' }}
          />
        ) : (
          <div className="py-16 text-center">
            <EditableToken
              path="accessibilitystatement.unavailable_message"
              as="p"
              className="font-body text-[var(--vibe-color-text-muted)]"
            >
              {unavailableMessage || 'Accessibility statement is not available at this time.'}
            </EditableToken>
          </div>
        )}
      </div>
    </section>
  );
}

export const contentSchema: ComponentContentSchema = {
  slot: 'AccessibilityStatement',
  displayName: 'Accessibility Statement',
  tokens: {
    'accessibilitystatement.unavailable_message': {
      label: 'Unavailable Message',
      type: 'text',
      defaultValue: 'Accessibility statement is not available at this time.',
    },
  },
};

(AccessibilityStatement as any).contentSchema = contentSchema;

export default AccessibilityStatement;
